import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ENV_CONFIG } from '../tokens/environment.token';
import { GetRecipeResponse } from '@chefami-monorepo/types';
import { ApiCacheService } from './api-cache.service';

@Injectable({
  providedIn: 'root',
})
export class RecipeService {
  private readonly env = inject(ENV_CONFIG);
  private readonly apiCache = inject(ApiCacheService);

  getAllRecipes(searchStr = ''): Observable<GetRecipeResponse> {
    const payload: Record<string, string> = { searchStr };

    // BaseHttpService already handles response.response.code === '0000' validation
    // and extracts response.response.data for us
    return this.apiCache.get<GetRecipeResponse>(
      this.env.getRecipeList,
      payload,
      `recipes_${searchStr}`,
      (response) => response.response.code === '0000'
    );
  }
}
